function setupPrivacyPage(root) {
  if (root.dataset.privacyReady) return;
  const body = root.querySelector('[data-privacy-body]');
  const list = root.querySelector('[data-privacy-index]');
  if (!body || !list) return;
  root.dataset.privacyReady = 'true';
  const headings = [...body.querySelectorAll('h2')];
  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `${root.querySelector('article').id}-section-${index + 1}`;
    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent.trim();
    item.append(link);
    list.append(item);
  });
  if (headings.length) list.closest('nav').hidden = false;
}
document.querySelectorAll('[data-privacy-page]').forEach(setupPrivacyPage);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('[data-privacy-page]').forEach(setupPrivacyPage);
});
